<div class="too-many-requests-container">
  <h2>{{ 'heading-title.too-many-requests' | translate }}</h2>
  <p>{{ 'paragraph-title.please-wait-a-few-moments-before-trying-again' | translate }}</p>
</div>
